import React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ApiResponse } from "../../../services/api";
import User from "../../../types/user";

interface UserTableProps {
  rows: any[];
  columns: GridColDef[];
  width?: string;
  getRowClassName?: (params: { indexRelativeToCurrentPage: number }) => string; 
  apiResponse: ApiResponse<User> | null;
  paginationModel: any; 
  setPaginationModel: any;
}

const UserTable: React.FC<UserTableProps> = ({
  rows,
  columns,
  width = "100%",
  getRowClassName,
  apiResponse,
  paginationModel,
  setPaginationModel,
}) => {
  return (
    <div style={{ height: '100%', width, display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, minHeight: 0 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        rowHeight={36}
        columnHeaderHeight={40}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 40 },
          },
        }}
        pageSizeOptions={[10, 20, 40, 100]}
        pagination
        checkboxSelection={false}
        getRowClassName={getRowClassName}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        sx={{
          "& .MuiDataGrid-row:nth-of-type(even)": {
            backgroundColor: "#f5f5f5",
          },
          "& .MuiDataGrid-row:nth-of-type(odd)": {
            backgroundColor: "white",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#b2d1ff",
          },
          "& .MuiTablePagination-selectLabel": {
            marginTop: "14px",
          },
          "& .MuiTablePagination-displayedRows": {
            marginTop: "14px",
          },
          "& .MuiDataGrid-cell[id='id']": {
            cursor: "pointer !important",
          },
          "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
          "& .MuiDataGrid-row:focus, & .MuiDataGrid-row:focus-within": {
            outline: "none",
          },
        }}
      />
      </div>
    </div>
  );
};

export default UserTable;
